import { Link } from "react-router-dom";
import { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { FEATURE_ACCOMPAGNEMENT, FEATURE_CORRESPONDANCE } from "../config/features";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [consent, setConsent] = useState(false);
  const [loading, setLoading] = useState(false);

  async function subscribe(e) {
    e.preventDefault();
    if (!consent) return toast.error("Merci d'accepter la politique de confidentialité");
    setLoading(true);
    try {
      await api.post("/newsletter/signup", { email, name, consent });
      toast.success("Merci — un mot doux et un cadeau arrivent dans ta boîte.");
      setEmail(""); setName(""); setConsent(false);
    } catch (err) {
      toast.error("Une erreur est survenue.");
    } finally { setLoading(false); }
  }

  return (
    <footer data-testid="site-footer" className="bg-[#F5F0E6] border-t border-[#E8DCC8] mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <h3 className="font-serif text-3xl text-[#2C2621] mb-3">Reçois un mot doux — et un petit cadeau</h3>
          <p className="text-[#4A4036] mb-5 leading-relaxed">Une lettre de temps en temps — un thème, une inspiration, jamais de bruit. À ton inscription, je t'offre <em>un premier RDV d'écriture</em> — une introduction douce à mon univers.</p>
          <form onSubmit={subscribe} className="space-y-4">
            <input data-testid="newsletter-name" className="field-input" placeholder="Ton prénom" value={name} onChange={(e)=>setName(e.target.value)}/>
            <input data-testid="newsletter-email" className="field-input" type="email" required placeholder="Ton email" value={email} onChange={(e)=>setEmail(e.target.value)}/>
            <label className="flex items-start gap-2 text-xs text-[#7C7064]">
              <input data-testid="newsletter-consent" type="checkbox" checked={consent} onChange={(e)=>setConsent(e.target.checked)} className="mt-1"/>
              <span>J'accepte de recevoir la newsletter et j'ai lu la <Link to="/confidentialite" className="underline">politique de confidentialité</Link>.</span>
            </label>
            <button data-testid="newsletter-submit" type="submit" disabled={loading} className="btn-primary">
              {loading ? "…" : "Recevoir mon cadeau"}
            </button>
          </form>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-serif text-xl mb-4">Naviguer</h4>
          <ul className="space-y-2 text-[#4A4036]">
            <li><Link to="/programme" className="hover:text-[#A3876A]">Rendez-vous d'écriture</Link></li>
            <li><Link to="/club-de-lettres" className="hover:text-[#A3876A]">Club de Lettres</Link></li>
            {FEATURE_ACCOMPAGNEMENT && (
              <li><Link to="/accompagnement" className="hover:text-[#A3876A]">Accompagnement</Link></li>
            )}
            {FEATURE_CORRESPONDANCE && (
              <li><Link to="/correspondance" className="hover:text-[#A3876A]">Correspondance</Link></li>
            )}
            <li><Link to="/carte-cadeau" className="hover:text-[#A3876A]">Offrir</Link></li>
            <li><Link to="/espace" className="hover:text-[#A3876A]">Mon espace</Link></li>
            <li><Link to="/a-propos" className="hover:text-[#A3876A]">À propos</Link></li>
            <li><Link to="/faq" className="hover:text-[#A3876A]">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-[#A3876A]">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="font-serif text-xl mb-4">Légal</h4>
          <ul className="space-y-2 text-[#4A4036]">
            <li><Link to="/mentions-legales" className="hover:text-[#A3876A]">Mentions légales</Link></li>
            <li><Link to="/cgv" className="hover:text-[#A3876A]">CGV</Link></li>
            <li><Link to="/confidentialite" className="hover:text-[#A3876A]">Politique de confidentialité</Link></li>
          </ul>
          <div className="mt-6">
            <h4 className="font-serif text-xl mb-3">Retrouve-moi</h4>
            <a
              data-testid="footer-instagram"
              href="https://www.instagram.com/les.rdv.de.lecriture"
              target="_blank"
              rel="noopener noreferrer me"
              className="inline-flex items-center gap-2 text-[#4A4036] hover:text-[#A3876A]"
              aria-label="Instagram — Les Rendez-vous de l'écriture"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <rect x="3" y="3" width="18" height="18" rx="5" />
                <circle cx="12" cy="12" r="4" />
                <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
              </svg>
              <span>@les.rdv.de.lecriture</span>
            </a>
          </div>
          <p className="text-xs text-[#7C7064] mt-6 leading-relaxed">
            © {new Date().getFullYear()} Les RDV de l'écriture. Fait avec attention en France.
          </p>
        </div>
      </div>
    </footer>
  );
}
